import { MutableRefObject, useLayoutEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import merge from 'lodash/merge';
import { getScrollPosition } from '../util';

export interface UseScrollPositionOptions {
  throttle?: number;
}

export const useScrollPosition = (ref?: MutableRefObject<HTMLElement>, options?: UseScrollPositionOptions) => {
  const [scrollPosition, setScrollPosition] = useState(getScrollPosition(ref?.current));

  options = merge({}, { throttle: 0 }, options);

  useLayoutEffect(() => {
    const target = ref?.current ? ref?.current : window;
    const handleScroll = debounce(() => setScrollPosition(getScrollPosition(ref?.current)), options.throttle);

    target.addEventListener('scroll', handleScroll);

    return () => target.removeEventListener('scroll', handleScroll);
  }, []);

  return scrollPosition;
};
